export const VeryWhite = "#ffffff"
export const AshBlack = "#292929"
export const AbitTransparentBlack = "rgba(0,0,0,0.505)"
